import { render, staticRenderFns } from "./DepartmentUserList.vue?vue&type=template&id=5b7b8ecb&scoped=true"
import script from "./DepartmentUserList.vue?vue&type=script&lang=js"
export * from "./DepartmentUserList.vue?vue&type=script&lang=js"
import style0 from "./DepartmentUserList.vue?vue&type=style&index=0&id=5b7b8ecb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7b8ecb",
  null
  
)

export default component.exports